(() => {
  const initGiftFinders = () => {
    document.querySelectorAll('[data-delulu-gift-finder]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const ageGroup = data.get('age_group');
        const playStyle = data.get('play_style');
        const budget = data.get('budget');
        const params = new URLSearchParams();
        if (ageGroup) params.set('filter.p.m.custom.age_groups', ageGroup);
        if (playStyle) params.set('filter.p.m.custom.play_styles', playStyle);
        if (budget) params.set('filter.v.price.lte', budget);
        params.set('filter.v.availability', '1');
        const query = params.toString();
        const collectionUrl = form.dataset.collectionUrl || '/collections/all';
        window.location.href = `${collectionUrl}${query ? `?${query}` : ''}`;
      });
    });
  };

  const initScrollButtons = () => {
    document.querySelectorAll('[data-delulu-scroll-target]').forEach((button) => {
      if (button.dataset.ready === 'true') return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const target = document.getElementById(button.dataset.deluluScrollTarget);
        if (!target) return;
        const direction = button.dataset.direction === 'previous' ? -1 : 1;
        target.scrollBy({ left: target.clientWidth * 0.82 * direction, behavior: 'smooth' });
      });
    });
  };

  const initProductActions = () => {
    const storageKey = 'delulu:saved-products';
    const readSavedProducts = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
        return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
      } catch (error) {
        console.warn('Unable to read saved products.', error);
        return [];
      }
    };
    const writeSavedProducts = (handles) => {
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(handles));
        return true;
      } catch (error) {
        console.warn('Unable to update saved products.', error);
        return false;
      }
    };
    const copyText = async (value) => {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value);
        return;
      }
      const input = document.createElement('textarea');
      input.value = value;
      input.setAttribute('readonly', '');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      const copied = document.execCommand('copy');
      input.remove();
      if (!copied) throw new Error('Copy command was not accepted.');
    };

    document.querySelectorAll('[data-delulu-product-actions]').forEach((container) => {
      if (container.dataset.ready === 'true') return;
      container.dataset.ready = 'true';
      const handle = container.dataset.productHandle;
      const saveButton = container.querySelector('[data-delulu-save-product]');
      const shareButton = container.querySelector('[data-delulu-share-product]');
      const status = container.querySelector('[data-delulu-product-action-status]');

      if (saveButton && handle) {
        const syncSaveButton = () => {
          const isSaved = readSavedProducts().includes(handle);
          const label = isSaved ? saveButton.dataset.removeLabel : saveButton.dataset.saveLabel;
          saveButton.setAttribute('aria-pressed', String(isSaved));
          saveButton.setAttribute('aria-label', label);
          saveButton.title = label;
        };
        syncSaveButton();
        saveButton.addEventListener('click', () => {
          const savedProducts = readSavedProducts();
          const isSaved = savedProducts.includes(handle);
          const updatedProducts = isSaved
            ? savedProducts.filter((savedHandle) => savedHandle !== handle)
            : [...savedProducts, handle];
          if (!writeSavedProducts(updatedProducts)) {
            if (status) status.textContent = saveButton.dataset.saveFailedLabel;
            return;
          }
          syncSaveButton();
          if (status) {
            status.textContent = isSaved ? saveButton.dataset.removedLabel : saveButton.dataset.savedLabel;
          }
        });
      }

      if (shareButton) {
        shareButton.addEventListener('click', async () => {
          const shareData = {
            title: shareButton.dataset.shareTitle,
            url: shareButton.dataset.shareUrl,
          };
          if (navigator.share) {
            try {
              await navigator.share(shareData);
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
              console.warn('Native product sharing failed; copying the link instead.', error);
            }
          }
          try {
            await copyText(shareData.url);
            if (status) status.textContent = shareButton.dataset.linkCopiedLabel;
          } catch (error) {
            console.warn('Unable to copy the product link.', error);
            if (status) status.textContent = shareButton.dataset.copyFailedLabel;
          }
        });
      }
    });
  };

  const init = () => {
    initGiftFinders();
    initScrollButtons();
    initProductActions();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
